/**
 * A hook that returns any categories for a given category.
 *
 * Takes an optional `limit` & `parentCategoryId`.
 *
 * - If `parentCategoryId` provided, will provide the sub categories of the provided parent.
 *
 * @module
 */
import { useCategory } from './useCategory';
import { useSelector } from '../actions/types';
import { categoryTree } from '../selectors';
import { throwIfDevelop } from '../utils';
/**
 *
 * # useCategories
 *
 * Usage example:
 * ```javascript
 * const MyCategoryList = ({
 *   limit,
 *   parentCategoryId,
 * }: UseCategoriesFilterOptions) => {
 *   const { categories, totalCount } = useCategories({ limit, parentCategoryId });
 *   if (!categories || categories.length === 0) return null;
 *
 *   return (
 *     <>
 *       <div>Total count: {totalCount}</div>
 *       <ul>
 *         {categories.map((subCat) => {
 *           return <li key={subCat.id}>{subCat.title}</li>;
 *         })}
 *       </ul>
 *     </>
 *   );
 * };
 * ```
 */
export function useCategories({ limit, parentCategoryId, } = {}) {
    const parentCategory = useCategory({ categoryId: parentCategoryId });
    if (parentCategoryId !== 'root' && parentCategoryId && !parentCategory) {
        throwIfDevelop(`Can't find parent category ${parentCategoryId} in useCategories`);
    }
    const categoriesInfo = useSelector((state) => {
        return categoryTree.categories(state, {
            parentCategoryId: (parentCategory === null || parentCategory === void 0 ? void 0 : parentCategory.id) || parentCategoryId || null,
            limit,
        });
    });
    return categoriesInfo;
}
//# sourceMappingURL=useCategories.js.map